/**
 * User: herbert
 * Date: 10.05.16
 * Time: 10:37
 */


// the whole app is presentation only so we disable jsx-ally
/* eslint jsx-a11y/onclick-has-role: 0 */
/* eslint jsx-a11y/img-has-alt: 0 */


import React from 'react';

import steleActions from '../../actions/stele-actions.js';

import T from '../../../../nls/translate.js';


function onChangeKasten(event) {
	steleActions.setKasten(event.target.checked);
}
function onChangeDoors(event) {
	steleActions.setExtraDoors(event.target.checked ? 1 : 0);
}

function onChangeDoors2(event) {
	steleActions.setExtraDoors(event.target.checked ? 2 : 1);
}

export default function(kasten, extraDoors, neededExtraDoors) {
	return [
			<span key="k" className="slx-stele-summary__kabelkasten" style={{marginRight: '3em'}} >
					<input type="checkbox" id="nnslxkkchk" onChange={onChangeKasten} checked={kasten} />
					<label htmlFor="nnslxkkchk">{T.current.SUMMARY.CABLEBOX}</label>
			</span>,
			<span key="d" className="slx-stele-summary__kabelkasten" >
				<input disabled={neededExtraDoors > 0} type="checkbox" id="nnslxadchk" onChange={onChangeDoors} checked={extraDoors > 0 || neededExtraDoors >= 1} />
				<label htmlFor="nnslxadchk">{T.current.SUMMARY.EXTRADOORS}</label>
			</span>,
			<span key="d2" className="slx-stele-summary__kabelkasten" >
				<input disabled={neededExtraDoors > 1} type="checkbox" id="nnslxadchk" onChange={onChangeDoors2} checked={extraDoors > 1 || neededExtraDoors >= 2} />
				<label htmlFor="nnslxadchk">{T.current.SUMMARY.EXTRADOORS2}</label>
			</span>
			// TODO Hinweis auf Kontakt wenn neededExtraDoors >= 2 Sollten Sie mehr Gobo und/oder Akzent!!! einsetzen wollen, kontaktieren Sie uns bitte.
		];
}
